import EditAccount from "./edit-account";

export default EditAccount;
